// src/components/AppItem.js

import React from 'react';
import PropTypes from 'prop-types';
import sri_logo from '../images/sri_logo_only.png';
import tsm_logo from '../images/TSM_LOGO.png';
import lap_logo from '../images/LAP_LOGO.png';
import fut_logo from '../images/FUT_LOGO.png';
import td_logo from '../images/TDKIP_LOGO.png'
import sheriff_logo from '../images/SFS_LOGO.png';
import zeus_logo from '../images/ZEUS_LOGO.png';
import noticing_sytem from '../images/NOTICING_LOGO.png';
import './AppItem.css'; // <--- Unique CSS file
const AppItem = ({ name, url, onAppSelect }) => {
  const getAppLogo = (appName) => {
    switch (appName.toLowerCase()) {
      case 'taxsale management system':   return tsm_logo;
      case 'lien assist program':         return lap_logo;
      case 'noticing':                    return noticing_sytem;
      case 'fut':                         return fut_logo;
      case "treasurer's deed":             return td_logo;
      case 'sheriff (foreclosure) sale':  return sheriff_logo;
      case 'zeus online auction':         return zeus_logo;
      default:                            return sri_logo;
    }
  };

  const appLogo = getAppLogo(name);

  const handleClick = (e) => {
    e.preventDefault();
    onAppSelect(url);
  };

  return (
    <div className="my-app-item-container">
      <a
        href={url}
        onClick={handleClick}
        className="my-app-item-link"
        aria-label={`Open ${name}`}
      >
        <img
          src={appLogo}
          alt=""
          aria-hidden="true"
          className="my-app-item-logo"
        />
        <span className="my-app-item-name">{name}</span>
      </a>
    </div>
  );
};

AppItem.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onAppSelect: PropTypes.func.isRequired,
};

export default AppItem;
